export function clearMenu() {
  document
    .querySelectorAll(".p-dynamic-menu-item")
    .forEach((el, i) => el.remove());
}
